import _taggedTemplateLiteral from 'babel-runtime/helpers/taggedTemplateLiteral';

var _templateObject = _taggedTemplateLiteral(['\n  ', '\n'], ['\n  ', '\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n          position: relative;\n          margin-top: 50px;\n          text-align: center;\n          width: 100%;\n        '], ['\n          position: relative;\n          margin-top: 50px;\n          text-align: center;\n          width: 100%;\n        ']),
    _templateObject3 = _taggedTemplateLiteral(['\n          justify-self: end;\n          @media (max-width: ', ') {\n            display: none;\n          }\n        '], ['\n          justify-self: end;\n          @media (max-width: ', ') {\n            display: none;\n          }\n        ']),
    _templateObject4 = _taggedTemplateLiteral(['\n  svg {\n    height: 15px;\n  }\n\n  ', '\n'], ['\n  svg {\n    height: 15px;\n  }\n\n  ', '\n']),
    _templateObject5 = _taggedTemplateLiteral(['\n      svg {\n        transform: rotate(180deg);\n      }\n    '], ['\n      svg {\n        transform: rotate(180deg);\n      }\n    ']),
    _templateObject6 = _taggedTemplateLiteral(['\n  position: absolute;\n  right: 0;\n  top: 50%;\n  transform: translateY(-50%);\n  padding: 5px 15px;\n  white-space: nowrap;\n  border: 1px solid ', ';\n\n  @media (max-width: ', ') {\n    position: relative;\n    margin: 15px auto 12px;\n    display: block;\n    transform: translateY(0);\n    top: auto;\n    right: auto;\n  }\n\n  ', ';\n'], ['\n  position: absolute;\n  right: 0;\n  top: 50%;\n  transform: translateY(-50%);\n  padding: 5px 15px;\n  white-space: nowrap;\n  border: 1px solid ', ';\n\n  @media (max-width: ', ') {\n    position: relative;\n    margin: 15px auto 12px;\n    display: block;\n    transform: translateY(0);\n    top: auto;\n    right: auto;\n  }\n\n  ', ';\n']),
    _templateObject7 = _taggedTemplateLiteral(['\n      background-color: ', ';\n      border-color: ', ';\n      color: ', ';\n    '], ['\n      background-color: ', ';\n      border-color: ', ';\n      color: ', ';\n    ']);

import styled, { css } from 'styled-components';

export var StyledDiv = styled.div(_templateObject, function (_ref) {
  var bottom = _ref.bottom,
      theme = _ref.theme;
  return bottom ? // bottom styling
  css(_templateObject2) : // top styling
  css(_templateObject3, theme.tabletWidth);
});

export var StyledButton = styled.button(_templateObject4, function (_ref2) {
  var prev = _ref2.prev;
  return prev &&
  // flip svg for prev
  css(_templateObject5);
});

export var StyledViewAllBtn = styled.button(_templateObject6, function (props) {
  return props.theme.dormifyBlack;
}, function (props) {
  return props.theme.mobileWidth;
}, function (_ref3) {
  var active = _ref3.active,
      theme = _ref3.theme;
  return active && css(_templateObject7, theme.dormifyBlack, theme.dormifyBlack, theme.dormifyWhite);
});